import FlowTimeLine from '@/components/FlowTimeLine/index.vue';
import PageDetailWrapper from '@/components/PageDetailWrapper/index.vue';
import PageWrapper from '@/components/PageWrapper/index.vue';
import SvgIcon from '@/components/SvgIcon/index.vue'; // svg component
import WeDateRangePicker from '@/components/WeDateRangePicker/index.vue';
import WeDialog from '@/components/WeDialog/index.vue';
import WeDrawer from '@/components/WeDrawer/index.vue';
import WeEditableWarp from '@/components/WeEditableWarp/index.vue';
import WeHWTimeLine from '@/components/WeHWTimeLine/index.vue';
import WeNumberRange from '@/components/WeNumberRange/index.vue';
import WeSelect from '@/components/WeSelect/index.vue';
import WeEditorInput from '@/components/WeEditorInput/index.vue';
import WeTab from '@/components/WeTab/index.vue';
import WeOssUpload from '@/components/WeUpload/OssUpload.vue';

import ModelFile from '@/views/crm/components/ModelFile.vue';
import InlineList from '@/views/crm/components/InlineList.vue';
import { WeTable } from '@/components/WeTable';
import TableAction from '@/components/WeTable/components/TableAction.vue';

import {
  Affix,
  Anchor,
  AnchorLink,
  AutoComplete,
  Avatar,
  List,
  BackTop,
  Breadcrumb,
  Button,
  Card,
  Cascader,
  Checkbox,
  Col,
  Collapse,
  ConfigProvider,
  Comment,
  DatePicker,
  Divider,
  Drawer,
  Dropdown,
  Form,
  Image,
  Input,
  InputNumber,
  InputPassword,
  Layout,
  Menu,
  Modal,
  Popover,
  Progress,
  Radio,
  Row,
  Select,
  Spin,
  Table,
  Tabs,
  Tag,
  Timeline,
  TimePicker,
  Tooltip,
  Transfer,
  Upload,
  Slider,
  Steps,
  Switch,
  Step,
  Pagination,
} from 'ant-design-vue';
import { App } from 'vue';

const compList = [
  Affix,
  Anchor,
  AnchorLink,
  AutoComplete,
  Avatar,
  List,
  List.Item,
  BackTop,
  Breadcrumb,
  Breadcrumb.Item,
  Button,
  Card,
  Cascader,
  Checkbox,
  Checkbox.Group,
  Col,
  Collapse,
  Collapse.Panel,
  ConfigProvider,
  Comment,
  Divider,
  Drawer,
  Dropdown,
  Form,
  Form.Item,
  Layout,
  Layout.Content,
  Layout.Header,
  Layout.Sider,
  Menu,
  Menu.SubMenu,
  Menu.Item,
  Menu.ItemGroup,
  Modal,
  Image,
  Input,
  InputNumber,
  InputPassword,
  Input.Group,
  Input.TextArea,
  Radio,
  Radio.Group,
  Row,
  Select,
  Select.Option,
  Table,
  Table.Column,
  Tag,
  Tabs,
  Tabs.TabPane,
  TimePicker,
  Timeline,
  Timeline.Item,
  Tooltip,
  Upload,
  Popover,
  SvgIcon,
  Spin,
  TableAction,
  DatePicker,
  DatePicker.MonthPicker,
  DatePicker.RangePicker,
  Transfer,
  WeNumberRange,
  WeTable,
  WeSelect,
  WeEditorInput,
  WeOssUpload,
  WeDialog,
  PageWrapper,
  Progress,
  PageDetailWrapper,
  WeDrawer,
  WeTab,
  WeEditableWarp,
  WeDateRangePicker,
  WeHWTimeLine,
  FlowTimeLine,
  Slider,
  Steps,
  Step,
  Switch,
  ModelFile,
  InlineList,
  Pagination,
];
export function registerUI(app: App) {
  compList.forEach((comp: any) => {
    app.component(comp.name || comp.displayName, comp);
  });
  app.component('a-select-option', Select.Option);
}
